import { mode } from "webconfig"

export const TrackingVideo09Purchase = (spot) => {
    switch (spot) {
        case 'a':
        case 'b':
        case 'c':
            if (mode === 'stage' && Array.isArray(window.dataLayer)) {
                window.dataLayer.push({
                    event: `tag_video09_purchase_${spot}`,
                })
            }
            break
        default:
            break
    }
}
export const TrackingVideo09Visit = (spot) => {
    switch (spot) {
        case 'c':
            if (mode === 'stage' && Array.isArray(window.dataLayer)) {
                window.dataLayer.push({
                    event: `tag_video09_visit_${spot}`,
                })
            }
            break
        default:
            break
    }
}

export const TrackingVideo09Contact = (spot) => {
    switch (spot) {
        case 'c':
            if (mode === 'stage' && Array.isArray(window.dataLayer)) {
                window.dataLayer.push({
                    event: `tag_video09_contact_${spot}`,
                })
            }
            break
        default:
            break
    }
}